import type { FC, PropsWithChildren, ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import type { SignalEventType } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/types";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";
import type SignalsTooltipViewModel from "app/pages/sales-intelligence/sub-modules/signals/models/view/signals-tooltip/SignalsTooltipViewModel";

import SignalsTooltipButtonLink from "../shared/SignalsTooltipButtonLink/SignalsTooltipButtonLink";
import SignalsTooltipContent from "../shared/SignalsTooltipContent/SignalsTooltipContent";
import SignalsTooltip from "../SignalsTooltip/SignalsTooltip";

import { StyledIntentTooltipText, StyledTooltipTableView } from "./styles";

type OverLimitViewProps = { items: SignalsTooltipViewModel["otherItems"] };

type Props = {
    key: string;
    redirectLink: URL["href"];
    getSignalTypeLink(eventType: SignalEventType): URL["href"];
    createViewModel(itemsLimit: number): SignalsTooltipViewModel;
    onViewAll(): void;
};

const SignalsIntentTooltip: FC<PropsWithChildren<Props>> = ({
    key,
    children,
    redirectLink,
    onViewAll,
    createViewModel,
    getSignalTypeLink,
}) => {
    const renderOverLimitView = ({ items }: OverLimitViewProps): ReactElement => {
        return (
            <StyledIntentTooltipText
                href={getSignalTypeLink(SignalType.Intent)}
                target="_blank"
            >
                {translate("si.signals.table-columns.tooltip.intent.text.more", {
                    count: items.length,
                })}
            </StyledIntentTooltipText>
        );
    };

    return (
        <SignalsTooltip
            key={key}
            content={
                <SignalsTooltipContent
                    title={translate(`si.signals.table-columns.tooltip.title.intent`)}
                    footer={
                        <SignalsTooltipButtonLink
                            text={translate("si.signals.table-columns.tooltip.view-company-overview.intent")}
                            redirectLink={redirectLink}
                            onClick={onViewAll}
                        />
                    }
                >
                    <StyledTooltipTableView
                        createViewModel={createViewModel}
                        renderOverLimitView={renderOverLimitView}
                    />
                </SignalsTooltipContent>
            }
        >
            <>{children}</>
        </SignalsTooltip>
    );
};

export default SignalsIntentTooltip;
